import React, { Component } from "react"
import autobind from "class-autobind"
import ExpenseGrid from "./ExpenseGrid"
import { IJobDocument, IExpenseTemplate, EExpenseScheduleTypeEnum } from "../../../../models"
import strings from "../../../../localization/strings"
import * as api from "../../../../api"
import AppStateStore from "../../../../stores/AppStateStore"
interface IProps {
    readonly?: boolean
    job: IJobDocument
    reloadJob(): void
}
interface IState {
    loading: boolean
    expenses: IExpenseTemplate[]
}

export default class JobDetailsExpenses extends Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            expenses: []
        }
        autobind(this)
    }

    componentDidMount() {
        this.getExpenses()
    }

    getExpenses() {
        this.setState({ loading: true }, () => {
            api.getJobExpenses(this.props.job.Id).then((expenses: any) => {
                this.setState({ loading: false, expenses: expenses.data })
            })
        })
    }

    addExpense(jobId: string, expense: IExpenseTemplate) {
        this.setState({ loading: true }, () => {
            api.addJobExpense(jobId, expense).then(() => {
                this.getExpenses()
                this.props.reloadJob()
            })
        })
    }

    updateExpense(jobId: string, expense: IExpenseTemplate) {
        this.setState({ loading: true }, () => {
            api.updateJobExpense(jobId, expense)
                .then(() => {
                    this.getExpenses()
                    this.props.reloadJob()
                })
                .catch(err => {
                    this.setState({ loading: false })
                    AppStateStore.setAlertDialogContent({
                        content: err.response.data.message
                    })
                })
        })
    }

    deleteExpense(jobId: string, expenses: string[]) {
        this.setState({ loading: true }, () => {
            api.deleteJobExpenses(jobId, expenses).then(() => {
                this.getExpenses()
                this.props.reloadJob()
            })
        })
    }

    render() {
        const oneTimeExpenseTemplate = (this.state.expenses || []).filter((x) => x.ExpenseScheduleType === EExpenseScheduleTypeEnum.OneTime)
        const recurringExpenseTemplate = (this.state.expenses || []).filter((x) => x.ExpenseScheduleType !== EExpenseScheduleTypeEnum.OneTime)
        return (
            <div className="user-detail-tab" style={{ padding: 30 }}>
                <ExpenseGrid
                    readonly={this.props.readonly}
                    job={this.props.job}
                    expenses={oneTimeExpenseTemplate}
                    tableName={strings.One_Time_Expense}
                    loading={this.state.loading}
                    getExpenses={this.getExpenses}
                    addExpense={this.addExpense}
                    deleteExpense={this.deleteExpense}
                    updateExpense={this.updateExpense}
                    isOneTime
                />
                <ExpenseGrid
                    readonly={this.props.readonly}
                    job={this.props.job}
                    expenses={recurringExpenseTemplate}
                    tableName={strings.Recurring_Expense}
                    showFrequencyControl={true}
                    loading={this.state.loading}
                    getExpenses={this.getExpenses}
                    addExpense={this.addExpense}
                    deleteExpense={this.deleteExpense}
                    updateExpense={this.updateExpense}
                />
            </div>
        )
    }
}
